import { render, staticRenderFns } from "./StudentMarksByMonthsWrapper.vue?vue&type=template&id=65b077c0"
import script from "./StudentMarksByMonthsWrapper.vue?vue&type=script&lang=js"
export * from "./StudentMarksByMonthsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports